import { LicenseInfo } from "@mui/x-license";

// VITE_MUIX_LICENSE env var takes precedence (e.g. for CI secret injection).
// Hardcoding is intentional per MUI recommendation: https://mui.com/x/introduction/licensing/#license-key-security
const key =
  import.meta.env?.VITE_MUIX_LICENSE?.trim() ??
  "7fd84d1b5216b7c67ec9185610d7b363Tz0xMjc5NDMsRT0xODExNDU1MjAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=";

LicenseInfo.setLicenseKey(key);
